export class PageRouteBuilder {
    static buildPageRoute = (currentPath: string, pageId: string, siteId?: string) => {
        return currentPath.indexOf("/preview/") !== -1?`/preview/${siteId}/${pageId}`:`/${pageId}`;
    }
}
